/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * How to handle open positions when stopping a strategy
 */
export enum PositionHandling {

    CloseAll = 'close_all',

    KeepOpen = 'keep_open',

    ReduceOnly = 'reduce_only'
}
